// FilterType contains the possible filter options for Med List.
export const FilterTypeMap = {
    ALL: 'ALL',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
};
const ListEndpointFetchAllRequestHttpQueryParams = (request) => {
    return {
        page_size: request.pagination?.page_size,
        page_token: request.pagination?.page_token,
        sort_type: request.sort_type,
        included_filters: request.included_filters,
        included_patient_ids: request.included_patient_ids,
    };
};
export const ListEndpoint = (makeRequest) => {
    return {
        // Fetch all medications for the Med List using pagination
        fetchAll(params, options) {
            return makeRequest('GET', '/v2/medications/list', ListEndpointFetchAllRequestHttpQueryParams(params), options);
        },
    };
};
//# sourceMappingURL=list_endpoint.js.map